<template>
  <form class="version version-3" name="step4_4">
    <input type="hidden" name="landing_type" value="cash">
    <div class="input-group_title">
      <h4>{{__t('Дані про працевлаштування')}}</h4>
    </div>
    <div class="form-wrap fw">
      <div class="input-field">
        <label><p>{{__t('Тип зайнятості')}}</p>
          <div class="select-wrapper">
            <select name="applicant_type" class="required activities" disabled>
              <option value="default">{{__t('Приватний підприємець')}}</option>
            </select>

            <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
          </div>
        </label>

      </div>
      <div class="input-field">
        <label>
          <p>{{__t('Дата реєстрації ФОП')}}</p>
          <div class="input-wrap">
            <input type="tel" name="employer_last_work_date" v-mask="'##.##.####'" placeholder="ДД.ММ.РРРР"
                   @input="hideBackEndError">

            <div v-show="typeof errorValidation.employer_last_work_date !== 'undefined'">
              <label class="error_back" style="color: red"
                     v-for="error in errorValidation.employer_last_work_date">{{error}}</label>
            </div>
          </div>
        </label>
      </div>
      <div class="input-field">
        <label>
          <p>{{__t('Вид діяльності')}}</p>
          <div class="select-wrapper input-wrap">
            <select name="employer_industry_type" @change="clearUnderSelect($event)" class="required activities">
              <option value="">{{__t('Оберіть')}}</option>
              <option :value="item.code" v-for="item in activitieskind">{{item.title}}</option>
            </select>

            <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
          </div>
        </label>
      </div>
      <div class="input-field" v-show="shortForm == 0 && shortForm !== ''">
        <label>
          <p>{{__t('Сфера діяльності')}}</p>
          <div class="select-wrapper input-wrap">
            <select name="field_of_activity" class="required activities">
              <option value="">{{__t('Оберіть')}}</option>
              <option :value="item.code" v-for="item in sferaActivities">{{item.title}}</option>
            </select>
            <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
          </div>
        </label>
      </div>
      <div class="input-field" v-show="shortForm == 0 && shortForm !== ''">
        <label>
          <p>{{__t('Система оподаткування')}}</p>
          <div class="select-wrapper input-wrap">
            <select name="employer_taxation_type" v-model="empTaxationType" class="required activities">
              <option value="">{{__t('Тип податку')}}</option>
              <option :value="item.code" v-for="item in taxsystem">{{item.title}}</option>
            </select>
            <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
          </div>
        </label>
      </div>
    </div>
    <div v-show="shortForm == '1'">
      <div class="input-group_title">
        <h4>{{__t('Дані про доходи')}}</h4>
      </div>
      <div class="form-wrap_group fw">
        <div class="input-field">
          <label>
            <p>{{__t('Офіційний місячний дохід, грн')}}</p>
            <div class="input-wrap">
              <input type="tel" name="income_gross" v-numericOnly placeholder="грн" pattern="^[0-9]+$">
              <div class="input-info_btn input-info-wrap">
                <img src="/img/cash-credit-landing/info-btn.svg">
                <div class="input-info_popup">
                  <p>{{__t('Підказка офіційний місячний дохід - cash - частина-1')}}</p>
                  <p>{{__t('Підказка офіційний місячний дохід - cash - частина-2')}}</p>
                </div>
              </div>
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>
            <p>{{__t('Сукупний місячний дохід, грн')}}</p>
            <div class="input-wrap">
              <input type="tel" name="income_net_1" v-numericOnly placeholder="грн" pattern="^[0-9]+$" >
              <div class="input-info_btn">
                <img src="/img/cash-credit-landing/info-btn.svg">
                <div class="input-info_popup">
                  <p>{{__t('Подсказка общий месячный доход')}}</p>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="" v-show="empTaxationType == 2 && ( profile_activities == 3 || profile_activities == 2 || profile_activities == 4) ">
      <!-- <div class="input-group_title">
        <h4>{{__t('Квартальна звітність')}}</h4>
      </div> -->
      <!-- <div class="form-wrap fw">
        <div class="input-field">
          <label>
            <p>{{__t('Вкажіть ваш дохід з декладації, грн')}}</p>
            <div class="input-wrap">
              <input type="tel" name="confirmed_earning_first_period_1" v-numericOnly pattern="^[0-9]+$"
                     :placeholder="'1 квартал ' + quarterperiod[1] + ' р'">
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>

            <div class="input-wrap">
              <input type="tel" name="confirmed_earning_second_period_1" v-numericOnly pattern="^[0-9]+$"
                     :placeholder="'2 квартал ' + quarterperiod[2] + ' р'">
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>
            <div class="input-wrap">
              <input type="tel" name="confirmed_earning_third_period_1" v-numericOnly pattern="^[0-9]+$"
                     :placeholder="'3 квартал ' + quarterperiod[3] + ' р'">
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>
            <div class="input-wrap">
              <input type="tel" name="confirmed_earning_fourth_period" v-numericOnly pattern="^[0-9]+$"
                     :placeholder="'4 квартал ' + quarterperiod[4] + ' р'">
            </div>
          </label>
        </div>
        <div class="info input-field fw">
          <img src="/img/cash-credit-landing/info-btn.svg">
          <p>{{__t('Якщо ви за певний рік подавали нульові декларації вкажіть в полі 0')}}</p>
        </div>
      </div> -->

      <div class="form-wrap fw">
        <div class="input-field">
          <label>
            <p>{{__t('Фактична середньомісячна виручка')}}</p>
            <div class="input-wrap">
              <input type="tel" name="income_gross_2" v-numericOnly placeholder="грн" pattern="^[0-9]+$">
              <div class="input-info_btn">
                <img src="/img/cash-credit-landing/info-btn.svg">
                <div class="input-info_popup">
                  <p>{{__t('Подсказка факт среднемесячная выручка')}}</p>
                </div>
              </div>
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>
            <p>{{__t('Чистий середньомісячний прибуток')}}</p>
            <div class="input-wrap">
              <input type="tel" name="income_net_2" v-numericOnly placeholder="грн" pattern="^[0-9]+$">
              <div class="input-info_btn">
                <img src="/img/cash-credit-landing/info-btn.svg">
                <div class="input-info_popup">
                  <p>{{__t('Подсказка чистый среднемесячный достаток')}}</p>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>


    </div>

    <div class="" v-show="empTaxationType == 3 && ( profile_activities == 3 || profile_activities == 2 || profile_activities == 4) ">
      <!-- <div class="input-group_title">
        <h4>{{__t('Річна звітність.')}}</h4>
      </div> -->
      <!-- <div class="form-wrap fw"> -->
        <!-- <div class="input-field">
          <label>
            <p>{{__t('Вкажіть ваш дохід з декладації, грн')}}</p>
            <div class="input-wrap">
              <input type="tel" name="confirmed_earning_first_period_2" v-numericOnly pattern="^[0-9]+$"
                     :placeholder="'За ' + periodforfop3[0] + ' р'">
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>

            <div class="input-wrap">
              <input type="tel" name="confirmed_earning_second_period_2" v-numericOnly pattern="^[0-9]+$"
                     :placeholder="'За ' + periodforfop3[1] + ' р'">
            </div>
          </label>
        </div> -->
       <!-- <div class="input-field">
          <label>
            <div class="input-wrap">
              <input type="tel" name="confirmed_earning_third_period_2" v-numericOnly pattern="^[0-9]+$"
                     :placeholder="'За ' + periodforfop3[2] + ' р'">
            </div>
          </label>
        </div>-->
        <!-- <div class="info input-field fw">
          <img src="/img/cash-credit-landing/info-btn.svg">
          <p>{{__t('Якщо ви за певний рік подавали нульові декларації вкажіть в полі 0')}}</p>
        </div> -->
      <!-- </div> -->

      <div class="form-wrap fw">
        <div class="input-field">
          <label>
            <p>{{__t('Фактична середньомісячна виручка')}}</p>
            <div class="input-wrap">
              <input type="tel" name="income_gross_3" v-numericOnly placeholder="грн" pattern="^[0-9]+$">
              <div class="input-info_btn">
                <img src="/img/cash-credit-landing/info-btn.svg">
                <div class="input-info_popup">
                  <p>{{__t('Подсказка факт среднемесячная выручка')}}</p>
                </div>
              </div>
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>
            <p>{{__t('Чистий середньомісячний прибуток')}}</p>
            <div class="input-wrap">
              <input type="tel" name="income_net_3" v-numericOnly placeholder="грн" pattern="^[0-9]+$">
              <div class="input-info_btn">
                <img src="/img/cash-credit-landing/info-btn.svg">
                <div class="input-info_popup">
                  <p>{{__t('Подсказка чистый среднемесячный достаток')}}</p>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>


    </div>

    <div class="button-group">
      <button type="button"
              @click.submit.prevent="goBack"
              class="popup-button btn green-btn colored-btn">
        {{__t('Повернутись назад')}}
      </button>
        <div class="button-wrapper page-bottom ">
          <button type="submit" class="btn red-btn">{{__t('Відправити заявку')}}</button>
        </div>
    </div>
  </form> <!--приватний підприємець. 4-->
</template>

<script>
    export default {
        name: "type_activity-4",
        data() {
            return {
                tax_choose: "default",
                profile_activities: '',
                errorValidation: {},
                sferaActivities: {},
                empTaxationType: ''
            }
        },
        props: [
            'taxsystem',
            'activitieskind',
            'periodforfop3',
            'quarterperiod'
        ],

        computed: {
            shortForm() {
                for (var key in this.activitieskind) {

                    if (this.activitieskind[key].code == this.profile_activities) {

                        return this.activitieskind[key].is_show_short_form;
                    }
                }

                return '';
            },

        },

        methods: {
            changeProfileActivities(e){
              this.profile_activities = e.target.value;
            },
            clearUnderSelect(e){
                this.empTaxationType = "";
                this.changeProfileActivities(e);
            },
            __t(phrase) {
                return window.__t(phrase);
            },
            hideBackEndError(el) {
                this.errorValidation.employer_last_work_date = [];
            },
            goBack() {
                this.$emit('goback');
                return false;
            },
            goNext() {
                this.$emit('gonext');
                return false;
            },
            validation: function () {
                let self = this;


                let form = $('[name=step4_4]').validate({
                    rules: {
                        employer_last_work_date: {
                            required: true,
                            regDay: true,
                        },
                        income_net_1: {
                            required: true,
                        },
                        income_gross: {
                            required: true,
                        },
                        income_gross_2: {
                            required: true,
                        },
                        income_net_2: {
                            required: true,
                        },
                        income_gross_3: {
                            required: true,
                        },
                        income_net_3: {
                            required: true,
                        },
                        employer_industry_type: {
                            required: true,
                        },
                      field_of_activity: {
                            required: true,
                        },
                        employer_taxation_type: {
                            required: true,
                        },

                        confirmed_earning_first_period_1: {
                            required: true,
                        },
                        confirmed_earning_first_period_2: {
                            required: true,
                        },
                        confirmed_earning_second_period_1: {
                            required: true,
                        },
                        confirmed_earning_second_period_2: {
                            required: true,
                        },
                        confirmed_earning_third_period_1: {
                            required: true,
                        },
                        confirmed_earning_third_period_2: {
                            required: true,
                        },
                        confirmed_earning_fourth_period: {
                            required: true,
                        }
                    },
                    messages: {
                        employer_last_work_date: {
                            required: __t('Заповніть поле'),
                        },
                        income_net_1: {
                            required: __t('Заповніть поле'),
                        },
                        income_gross: {
                            required: __t('Заповніть поле'),
                        },
                        income_gross_2: {
                            required: __t('Заповніть поле'),
                        },
                        income_net_2: {
                            required: __t('Заповніть поле'),
                        },
                        income_gross_3: {
                            required: __t('Заповніть поле'),
                        },
                        income_net_3: {
                            required: __t('Заповніть поле'),
                        },
                        employer_industry_type: {
                            required: __t('Заповніть поле'),
                        },
                      field_of_activity: {
                            required: __t('Заповніть поле'),
                        },
                        employer_taxation_type: {
                            required: __t('Заповніть поле'),
                        },
                        confirmed_earning_first_period_1: {
                            required: __t('Заповніть поле'),
                        },
                        confirmed_earning_first_period_2: {
                            required: __t('Заповніть поле'),
                        },
                        confirmed_earning_second_period_1: {
                            required: __t('Заповніть поле'),
                        },
                        confirmed_earning_second_period_2: {
                            required: __t('Заповніть поле'),
                        },
                        confirmed_earning_third_period_1: {
                            required: __t('Заповніть поле'),
                        },
                        confirmed_earning_third_period_2: {
                            required: __t('Заповніть поле'),
                        },
                        confirmed_earning_fourth_period: {
                            required: __t('Заповніть поле'),
                        }

                    },
                    errorPlacement: function (error, element) {
                        error.insertAfter(element);
                    },
                    submitHandler: function (form) {

                        var data = $('[name=step4_4]').serializeArray();

                        self.$emit('openPreloader');

                        jQuery.ajax({
                          headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                          },
                            data: data,
                            type: "POST",
                            url: '/cash/step4',
                            cache: false,
                            dataType: "json",
                            success: function (response) {
                                if (response.status == 'refusing') {
                                    self.$emit('error');
                                } else if (response.status == 'callback') {
                                    self.$emit('call');
                                } else {
                                    self.$emit('success');
                                }
                                self.$emit('closePreloader');
                                // self.$emit('returnbegin');
                            },
                            error: function (error) {
                                self.errorValidation = error.responseJSON;
                                self.$emit('closePreloader');
                            }
                        });

                    }
                });
            }
        },

        watch: {
            profile_activities(val) {

                var self = this;

                jQuery.ajax({
                  headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                  },
                    data: {
                        'profile_activities': val
                    },
                    type: "POST",
                    url: '/cash/profile-activities-change',
                    cache: false,
                    dataType: "json",
                    success: function (response) {
                        self.sferaActivities = response;
                    },
                    error: function (error) {

                    }
                });
            }
        },

        mounted() {
            this.validation();

            $('.input-info_btn').on('mouseover', function (el) {
              this.querySelector('.input-info_popup').style.visibility = "visible";
            });


            $('.input-info_btn').on('mouseout', function (el) {
              this.querySelector('.input-info_popup').style.visibility = "hidden";
            });

        }
    }
</script>

<style>
.input-info-wrap {
  z-index: 2;
}
.input-info-wrap .input-info_popup {
  width: 200px;
}
</style>
